const preBuyUtils = new window.PreBuyUtils()

class QuickAddToCart extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.onClickHandler)
  }

  async onClickHandler () {
    try {
      const variantId = this.dataset.variantId
      const productId = this.dataset.productId

      let properties = {}
      let sellingPlanId = ''

      const preBuyData = await preBuyUtils.getPreBuyData(productId, variantId)

      if (preBuyData?.enabled && preBuyData?.variantPool) {
        const pool = preBuyData.variantPool

        sellingPlanId =
          pool?.sellingPlanId?.replace('gid://shopify/SellingPlan/', '') || ''

        properties = {
          _preorder: true,
          [window.theme?.strings?.estimatedDispatchPrefix ||
          'Pre-order']: pool?.estDispatchDateFormatted,
          _pool_location: pool?.location,
          _locationId: pool?.locationId,
          _dispatch_date: pool?.zonedEstDispatchDate,
        }

        const date = new Date(pool?.zonedEstDispatchDate)
        const month = date.getMonth() + 1
        properties._start_date = `${String(month).padStart(2, '0')}/${String(
          date.getDate(),
        ).padStart(2, '0')}/${date.getFullYear()}`
      } else if (
        this.dataset.variantAvailable === 'true' &&
        this.dataset.preorder === 'true'
      ) {
        if (this?.dataset?.dispatch) {
          const dispatchKey = window.theme.strings.estimatedDispatchPrefix
          properties = { [dispatchKey]: this.dataset.dispatch, _preorder: true }
        } else {
          properties = { _preorder: true }
        }
      }

      // --- Add to cart ---
      window.BAO.Cart.addItem({
        id: parseInt(variantId),
        quantity: 1,
        ...(sellingPlanId ? { selling_plan: parseInt(sellingPlanId, 10) } : {}),
        ...(Object.keys(properties).length ? { properties } : {}),
      })
    } catch (error) {
      console.error('Error adding variant:', error)
    }
  }
}

customElements.define('quick-add-to-cart', QuickAddToCart, {
  extends: 'button',
})
